import Show from '@/components/Show';
import useGeneratorStore, { GeneratorTypeEnums } from '@/state/generator-store';
import React from 'react';
import GenerateButton from '../GenerateButton';
import PromptTextTextarea from '../PromptTextArea/PromptTextTextarea';
import DurationInput from './DurationInput';
import { MobileEffectsButton } from './EffectsButton';
import FolderSelectorCard from './FolderSelectorCard';
import FormatSwitch from './FormatSwitch';
import SimplePromptInput from './SimplePromptInput';

interface OldMobileSimpleEffectsProps {
  disabled: boolean;
}

const OldMobileSimpleEffects: React.FC<OldMobileSimpleEffectsProps> = ({ disabled }) => {
  const { setIsGeneratorDrawerShow, isGeneratorDrawerShow, generatorType } = useGeneratorStore();

  return (
    <div>
      <div className="flex flex-col px-3 py-4 bg-[#212224] rounded-t-lg">
        <Show when={isGeneratorDrawerShow && generatorType === GeneratorTypeEnums.TEXT}>
          <>
            <div
              className="w-full h-full"
              style={{
                background: 'linear-gradient(#191A1B, #1E2021)',
                boxShadow: 'inset 2px 2px 12px rgba(0, 0, 0, 1)',
              }}
            >
              <PromptTextTextarea />
            </div>
            <div className="flex">
              <DurationInput theme="dark" className="mt-2" />
              <FormatSwitch />
            </div>
            <FolderSelectorCard className="mt-2" />
          </>
        </Show>
        {!isGeneratorDrawerShow && <SimplePromptInput />}
      </div>
      <div className="flex w-full">
        <div className="flex h-20 flex-1 items-center min-w-[330px]">
          <GenerateButton type="submit" onClick={() => setIsGeneratorDrawerShow(false)} disabled={disabled} />
        </div>
        <MobileEffectsButton type="button" open={isGeneratorDrawerShow} onClick={() => setIsGeneratorDrawerShow(!isGeneratorDrawerShow)} />
      </div>
    </div>
  );
};

export default OldMobileSimpleEffects;
